import { mapGetters } from 'vuex';

export default {
  props: {
    shutdown: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: '',
    },
  },
  methods: {
    onClick() {
      if (this.shutdown) {
        window.location.href = 'https://twitter.com/PredictIt';
      } else {
        this.$router.push({ name: 'research' });
      }
    },
  },
  computed: {
    classModifiers() {
      return {
        'research-widget': true,
        [`research-widget--${this.theme}`]: this.theme,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/research-widget/research-widget.js